import { SimpleTableHeadColumn } from '../configuration-files/types';

export const headCells: SimpleTableHeadColumn[] = [
  {
    id: 'eucid',
    label: 'EUCID',
    accessor: 'ecuId',
  },
  {
    id: 'fault-code-type-indicator',
    label: 'Fault Codes Type Indicator',
    accessor: 'faultCodeTypeIndicator',
  },
  {
    id: 'code',
    label: 'Code',
    accessor: 'code',
  },
  {
    id: 'fmi',
    label: 'FMI',
    accessor: 'fmi',
  },
  {
    id: 'wci',
    label: 'WCI',
    accessor: 'wci',
  },
  {
    id: 'status',
    label: 'Status',
    accessor: 'status',
  },
];
